import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ThemeContext } from '../../context/ThemeContext';
import { getContrastColor } from '../../utils/colorUtils';
import { PageWrapper, Container, PageTitle, FaqItem, Question, Answer } from './FAQ.styles';

const FAQS = [
  { q: '¿Es gratuito publicar anuncios?', a: 'Sí, publicar anuncios en trasteroweb.es es completamente gratuito para particulares. No cobramos comisiones por vender.' },
  { q: '¿Cómo contacto con un vendedor?', a: 'Desde cualquier anuncio puedes enviar un mensaje directo al vendedor haciendo clic en el icono de chat. Necesitas estar registrado.' },
  { q: '¿trasteroweb.es interviene en el pago?', a: 'No. trasteroweb.es es solo un tablón de anuncios. El pago y la entrega se acuerdan directamente entre comprador y vendedor fuera de la plataforma.' },
  { q: '¿Puedo proponer un trueque?', a: 'Sí. Al publicar un anuncio puedes indicar que aceptas cambio. El trueque se acuerda directamente entre las partes.' },
  { q: '¿Cómo elimino mi cuenta?', a: 'Puedes solicitar la eliminación de tu cuenta enviando un email a privacidad@trasteroweb.es. Tus datos se eliminarán en un plazo máximo de 30 días.' },
  { q: '¿Qué hago si un artículo no corresponde a lo anunciado?', a: 'Puedes reportar el anuncio usando el botón de reporte en la imagen del artículo. También puedes contactarnos en abuse@trasteroweb.es.' },
  { q: '¿Mis datos están seguros?', a: 'Sí. Cumplimos con el RGPD y la LOPD-GDD. Consulta nuestra Política de Privacidad para más información.' },
  { q: '¿Puedo publicar artículos de empresa?', a: 'trasteroweb.es está pensado para particulares (C2C). La publicación de artículos con finalidad comercial profesional no está permitida.' },
];

export default function FAQ() {
  const { theme } = useContext(ThemeContext);
  const bg  = theme.background || '#000';
  const acc = theme.accent     || '#667eea';
  const txt = getContrastColor(bg);
  const [open, setOpen] = useState(null);

  return (
    <PageWrapper bg={bg}>
      <Helmet>
        <title>Preguntas frecuentes · Trastero</title>
        <meta name="description" content="Resuelve tus dudas sobre cómo funciona Trastero: publicar anuncios, contactar vendedores, pagos y más." />
      </Helmet>
      <Container>
        <PageTitle color={txt}>Preguntas frecuentes</PageTitle>
        {FAQS.map((item, i) => (
          <FaqItem key={i} accent={acc} $open={open === i} onClick={() => setOpen(open === i ? null : i)}>
            <Question color={txt} accent={acc} $open={open === i}>
              {item.q}
              <span>{open === i ? '−' : '+'}</span>
            </Question>
            {open === i && <Answer color={txt}>{item.a}</Answer>}
          </FaqItem>
        ))}
      </Container>
    </PageWrapper>
  );
}
